import { createContext, useReducer, useState } from "react";
import { SESSION_EXPIRE, SESSION_TOKEN, SESSION_USER } from "../Utils/constants.api";

export const AuthContext = createContext({})

export const AuthProvider = ({children}) => {
    const userLocalStorage = window.localStorage.getItem(SESSION_USER)
    const tokenLocalStoage = window.localStorage.getItem(SESSION_TOKEN)
    const expireLocalStorage = window.localStorage.getItem(SESSION_EXPIRE)

    const [sessionUser, setSessionUser] = useState(
        userLocalStorage ? JSON.parse(userLocalStorage) : null
    )

    const [token, setToken] = useState(
        tokenLocalStoage ?? null
    )

    const [expireAt, setExpireAt] = useState(
        expireLocalStorage ?? null
    )

    return (
        <AuthContext.Provider value={{
            sessionUser,
            setSessionUser,
            token,
            setToken,
            expireAt,
            setExpireAt,
        }}>
            {children}
        </AuthContext.Provider>
    )
}